import { httpBase } from './httpBaseUtil';

export function fetch(endpoint, params) {
  return httpBase().get(`/${endpoint}`, { params });
}

export function cancelFetch(endpoint, cancelToken) {
  return httpBase(false, cancelToken).get(`/${endpoint}`);
}

export function store(endpoint, data) {
  return httpBase().post(`/${endpoint}`, data);
}

export function cancelStore(endpoint, data, cancelToken) {
  return httpBase(false, cancelToken).post(`/${endpoint}`, data);
}

export function update(endpoint, data) {
  return httpBase().put(`/${endpoint}`, data);
}

export function destroy(endpoint, params) {
  return httpBase().delete(`/${endpoint}`, { params });
}

export function download(endpoint, params) {
  return httpBase(true).get(`/${endpoint}`, { params });
}

export function downloadReport(endpoint, data) {
  return httpBase(true).post(`/${endpoint}`, data);
}
